<template>
	<div data-tour-scope="blog">
		<v-main>
			<v-container fluid class="bl-page">
				<div class="bl-top">
					<div>
						<div class="bl-title">Blog</div>
						<div class="bl-muted">Gli articoli li scrive l'IA partendo dai tuoi prodotti e dalle tue regole: tu li rileggi e li pubblichi.</div>
					</div>
					<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
					<v-spacer></v-spacer>
					<v-btn depressed color="primary" data-tour="add" @click="createItem"><v-icon left>mdi-robot-outline</v-icon>Genera piano del mese con l'IA</v-btn>
				</div>

				<BlogSettings :blog="blog" :langs="langs" :aperto="impostazioniAperte" @apri="impostazioniAperte = !impostazioniAperte" @salva="saveSetting" />

				<SectionCard title="Articoli" icon="mdi-post-outline" :subtitle="total === 1 ? '1 articolo' : total + ' articoli'" class="mt-4">
					<div class="bl-filters" data-tour="filters">
						<v-text-field
							v-model="searchfield"
							label="Cerca per titolo"
							outlined
							dense
							hide-details
							prepend-inner-icon="mdi-magnify"
							clearable
							class="bl-search"
							@keyup.enter="getSearch()"
							@click:clear="pulisciRicerca"
						/>
						<div class="bl-states">
							<v-chip small :outlined="settings.filters.status !== ''" :color="settings.filters.status === '' ? 'primary' : undefined" @click="settings.filters.status = ''">Tutti</v-chip>
							<v-chip
								v-for="(s, codice) in STATI"
								:key="codice"
								small
								:outlined="settings.filters.status !== codice"
								:color="settings.filters.status === codice ? s.colore : undefined"
								:text-color="settings.filters.status === codice ? 'white' : undefined"
								@click="settings.filters.status = codice"
							>
								<v-icon x-small left>{{ s.icona }}</v-icon
								>{{ s.label }}
							</v-chip>
						</div>
					</div>

					<div v-if="!getItems.length" class="bl-empty">
						<v-icon large color="grey lighten-1">mdi-post-outline</v-icon>
						<div>Nessun articolo{{ settings.filters.status || settings.search ? ' con questi filtri' : '' }}.</div>
						<div class="bl-muted">Con il servizio acceso e le regole scritte, "Genera piano del mese con l'IA" prepara gli articoli.</div>
					</div>

					<v-data-table
						v-else
						:headers="headers"
						:items="getItems"
						:options.sync="settings.options"
						:server-items-length="total"
						must-sort
						class="elevation-0"
						:footer-props="{ 'items-per-page-options': listSize }"
						item-key="_id"
						data-tour="table"
						:hide-default-header="mobileCards"
						:class="{ 'table-cards': mobileCards }"
					>
						<template v-slot:body="{ items }">
							<!-- telefono: ogni articolo diventa una card -->
							<tbody v-if="mobileCards" class="blog-cards">
								<tr v-for="item in items" :key="item._id">
									<td :colspan="headers.length" class="px-0 py-1">
										<key-value-card :title="titolo(item)" :fields="campiCard(item)" :image="item.image || ''">
											<template #actions>
												<v-btn small icon color="primary" :title="aperto(item) ? 'Chiudi' : 'Anteprima'" @click="apri(item)">
													<v-icon>{{ aperto(item) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
												<v-menu top eager>
													<template v-slot:activator="{ on, attrs }">
														<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu"><v-icon>mdi-dots-vertical</v-icon></v-btn>
													</template>
													<v-list>
														<v-list-item link data-tour="row-edit" @click="editItem(item)"><v-list-item-title class="size9">Modifica</v-list-item-title></v-list-item>
														<v-list-item link data-tour="row-delete" @click="deleteItem(item)"><v-list-item-title class="size9">Elimina</v-list-item-title></v-list-item>
													</v-list>
												</v-menu>
											</template>
											<BlogArticleDetail v-if="aperto(item)" :item="item" @edit="editItem(item)" @delete="deleteItem(item)" />
										</key-value-card>
									</td>
								</tr>
							</tbody>
							<tbody v-else>
								<template v-for="item in items">
									<tr :key="item._id">
										<td class="pl-1 pr-0 text-no-wrap" style="width: 76px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu"><v-icon>mdi-dots-vertical</v-icon></v-btn>
												</template>
												<v-list>
													<v-list-item link data-tour="row-edit" @click="editItem(item)"><v-list-item-title class="size9">Modifica</v-list-item-title></v-list-item>
													<v-list-item link data-tour="row-delete" @click="deleteItem(item)"><v-list-item-title class="size9">Elimina</v-list-item-title></v-list-item>
												</v-list>
											</v-menu>
											<v-btn small icon color="primary" data-tour="row-expand" :title="aperto(item) ? 'Chiudi' : 'Anteprima'" @click="apri(item)">
												<v-icon>{{ aperto(item) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
											</v-btn>
										</td>
										<td style="width: 76px">
											<div class="bl-thumb">
												<img v-if="item.image" :src="item.image" alt="" loading="lazy" />
												<v-icon v-else small color="grey lighten-1">mdi-image-off-outline</v-icon>
											</div>
										</td>
										<td class="text-left">
											<div class="font-weight-medium">{{ titolo(item) }}</div>
											<div v-if="item.item" class="bl-muted"><v-icon x-small class="mr-1">mdi-shopping-outline</v-icon>{{ item.item }}</div>
										</td>
										<td>
											<v-chip x-small label outlined :color="stato(item.status).colore"
												><v-icon x-small left>{{ stato(item.status).icona }}</v-icon
												>{{ stato(item.status).label }}</v-chip
											>
										</td>
										<td class="text-no-wrap">
											<template v-if="item.publishedAt">
												<div>{{ item.publishedAt | moment('DD/MM/YYYY') }}</div>
												<div class="bl-muted">{{ quando(item.publishedAt) }}</div>
											</template>
											<span v-else class="bl-muted">—</span>
										</td>
									</tr>
									<tr v-if="aperto(item)" :key="item._id + '-detail'" class="bl-expanded">
										<td :colspan="headers.length" class="py-3">
											<BlogArticleDetail :item="item" @edit="editItem(item)" @delete="deleteItem(item)" />
										</td>
									</tr>
								</template>
							</tbody>
						</template>
					</v-data-table>
				</SectionCard>

				<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" multi-line :timeout="snackbar.timeout">
					{{ snackbar.text }}
					<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
				</v-snackbar>
			</v-container>
		</v-main>


		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando l'articolo non potrai più ripristinarlo: se è pubblicato sparisce dal sito.</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="error" text @click="confirmDelete"> Elimina </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogGenera" max-width="360">
			<v-card>
				<v-card-title class="headline">Generare il piano del mese?</v-card-title>
				<v-card-text class="text-left">L'IA scrive gli articoli nuovi seguendo le regole del blog. Restano da rileggere: online ci vanno solo quando li porti a Pubblicato.</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="dialogGenera = false"> Annulla </v-btn>
					<v-btn color="primary" text @click="confirmGenera"> Genera </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createBlogTourSteps, stopBlogTour } from './blog-tour';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import SectionCard from '@/components/core/SectionCard.vue';
import BlogSettings from '@/components/blog/BlogSettings.vue';
import BlogArticleDetail from '@/components/blog/BlogArticleDetail.vue';
import { STATI, stato, quando, titolo } from '@/components/blog/formato';
import { listRouteState } from '@/components/core/list/listRouteState';

const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'Blog',
	// pagina, righe, ordinamento, ricerca e stato stanno nell'URL: refresh e ritorno dalla scheda ripartono da li'
	mixins: [listRouteState({ filters: { status: 'string' }, perPageOptions: LIST_SIZE })],
	setup() {
		return { tour: useTour(createBlogTourSteps(), { onStop: stopBlogTour }) };
	},
	components: {
		TourOverlay,
		KeyValueCard,
		SectionCard,
		BlogSettings,
		BlogArticleDetail,
	},
	data() {
		return {
			snackbar: { snackbar: false, color: '', timeout: 5000, text: '' },
			settings: this.listSettingsFromRoute({
				search: '',
				filters: { status: '' },
				options: { sortBy: ['publishedAt'], sortDesc: [true], page: 1, itemsPerPage: 15 },
			}),
			listSize: LIST_SIZE,
			searchfield: '',
			total: 0,
			headers: [
				// colonne del menu a tre puntini e dell'immagine: non si ordinano
				{ text: '', value: '', sortable: false },
				{ text: '', value: 'image', sortable: false },
				{ text: 'Articolo', value: 'name.name' },
				{ text: 'Stato', value: 'status' },
				{ text: 'Pubblicazione', value: 'publishedAt' },
			],
			STATI,
			// articoli con l'anteprima aperta (+)
			aperti: [],
			// riquadro "Regole e impostazioni" aperto
			impostazioniAperte: false,
			dialogconfirm: false,
			daEliminare: null,
			dialogGenera: false,
			blog: {
				active: false,
				setting: { times: 0, preview: '', article: '', image: '', share: [], lang: '' },
				type: 'blog',
				service: 'blog',
			},
			langs: [],
		};
	},
	async mounted() {
		this.listLoad();
		await Promise.all([this.fetchSetting(), this.fetchService(['blog', 'facebook', 'instagram', 'tiktok'])]);
		this.langs = this.getSettings.languages.filter(el => el.is_active);
		const blog = _.find(this.getServices, { service: 'blog' });
		if (blog) {
			const s = blog.setting || {};
			this.blog = {
				active: blog.active,
				setting: {
					times: s.times ? s.times : '',
					preview: s.preview ? s.preview : '',
					article: s.article ? s.article : '',
					image: s.image ? s.image : '',
					share: s.share ? s.share : '',
					lang: s.lang ? s.lang : '',
				},
				type: 'blog',
				service: 'blog',
			};
		}
	},
	computed: {
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',
			getItems: 'blog/getItems',
			getSettings: 'settings/getSetting',
			getServices: 'services/getServices',
		}),
	},
	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setPreload: 'settings/setPreload',
		}),
		...mapActions({
			fetchService: 'services/getServiceFetch',
			fetchItems: 'blog/asyncFetchData',
			createItems: 'blog/createData',
			destroyData: 'blog/destroyData',
			fetchSetting: 'settings/asyncFetchData',
			setService: 'services/updateData',
		}),
		campiCard(item) {
			return [
				{ label: 'Stato', value: stato(item.status).label, strong: true },
				{ label: 'Pubblicazione', value: item.publishedAt ? `${this.$moment(item.publishedAt).format('DD/MM/YYYY')} · ${quando(item.publishedAt)}` : '' },
				{ label: 'Prodotto', value: item.item },
			];
		},
		stato,
		quando,
		titolo,
		aperto(item) {
			return this.aperti.includes(item._id);
		},
		apri(item) {
			this.aperti = this.aperto(item) ? this.aperti.filter(id => id !== item._id) : [...this.aperti, item._id];
		},
		notifica(color, text) {
			this.snackbar = { snackbar: true, color, timeout: 5000, text };
		},
		// il mixin della lista riporta a pagina 1 e ricarica quando cambia la ricerca
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= 3 ? this.searchfield : '';
		},
		pulisciRicerca() {
			this.searchfield = '';
			this.getSearch();
		},
		saveSetting() {
			this.setPreload(true);
			axios
				.post(`${this.getUrl}services/update`, this.blog, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					this.setService(data.data);
					this.notifica('success', 'Operazione effettuata con successo');
				})
				.catch(err => {
					const errors = err.response && err.response.data && err.response.data.error;
					this.notifica('error', errors && !_.isArray(errors) ? errors : err.message);
					if (err.response && err.response.status === 401) {
						this.setLogout();
						this.$router.push('/login');
					}
				})
				.finally(() => this.setPreload(false));
		},
		// la scheda dell'articolo e' una pagina: la lista resta nel suo URL e ci si torna uguale
		editItem(item) {
			this.$router.push(`/ecommerce/blogs/${item._id}`);
		},
		// "Genera piano del mese": l'IA scrive articoli nuovi, quindi prima si chiede conferma
		createItem() {
			this.dialogGenera = true;
		},
		async confirmGenera() {
			this.dialogGenera = false;
			this.setPreload(true);
			try {
				await this.createItems();
				await this.getDataFromApi();
			} catch (err) {
				console.log(err);
			} finally {
				this.setPreload(false);
			}
		},
		getDataFromApi() {
			this.setPreload(true);
			return this.fetchItems(this.settings)
				.then(result => {
					this.total = result ? result.total : 0;
				})
				.catch(err => console.log(err))
				.finally(() => this.setPreload(false));
		},
		deleteItem(item) {
			this.daEliminare = item;
			this.dialogconfirm = true;
		},
		confirmDelete() {
			this.dialogconfirm = false;
			if (!this.daEliminare) return;
			this.setPreload(true);
			axios
				.delete(`${this.getUrl}blogs/${this.daEliminare._id}`, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => this.getDataFromApi())
				.then(() => this.notifica('success', 'Operazione effettuata con successo'))
				.catch(error => console.log(error))
				.finally(() => {
					this.daEliminare = null;
					this.setPreload(false);
				});
		},
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
};
</script>

<style scoped>
.bl-page {
	max-width: 1600px;
}
.bl-top {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px 12px;
	margin-bottom: 16px;
}
.bl-title {
	font-size: 20px;
	font-weight: 600;
	color: #1f2d3d;
}
.bl-muted {
	font-size: 12px;
	color: #5f6b7a;
}
.bl-page ::v-deep .section-card {
	height: auto;
}
.bl-filters {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 10px 16px;
	margin-bottom: 8px;
}
.bl-search {
	flex: 0 1 340px;
}
.bl-states {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
}
.bl-empty {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
	padding: 32px 16px;
	text-align: center;
	color: #1f2d3d;
}
.bl-thumb {
	width: 64px;
	height: 44px;
	border-radius: 6px;
	overflow: hidden;
	background: #f3f6fa;
	display: flex;
	align-items: center;
	justify-content: center;
}
.bl-thumb img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.bl-expanded,
.bl-expanded:hover {
	background: transparent !important;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.blog-cards,
.blog-cards tr {
	display: block;
	width: 100%;
}
.blog-cards tr,
.blog-cards tr:hover {
	background: transparent !important;
}
.blog-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.blog-cards tr:first-child td {
	padding-top: 12px !important;
}
.blog-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.blog-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
</style>
